import { connect } from 'react-redux'
import { getProp } from '../../../../../redux/selectors/kegCollectionBookings'
import KegCollectionBookingDetails from './KegCollectionBookingDetails/KegCollectionBookingDetails'
import withNoPermissions from '../../../OperateAsCustomerUser/withNoPermissions'
import { getProp as getCurrentUserProps } from '../../../../../redux/selectors/currentUser'
import { getProp as getCurrentUserEmployeeProp } from '../../../../../redux/selectors/currentUserEmployee'

const mapStateToProps = state => {
  const { bookingDetails, collectorsList } = getProp(state)
  const currentUserOperateAs = getCurrentUserProps(state)
  const currentUserEmployee = getCurrentUserEmployeeProp(state)
  return {
    bookingDetails,
    collectorsList,
    currentUserOperateAs,
    currentUserEmployee,
  }
}

export default withNoPermissions(connect(mapStateToProps)(KegCollectionBookingDetails))
